// extracted by mini-css-extract-plugin
export default {"hideTooltip":"S8-z","fadeIn":"T8-z","delay":"U8-z","recommendedSizeTooltip":"V8-z"};